import { DSText } from '@zoe/ds-web'
import React, { useContext } from 'react'

import { GeoContext } from '@/context/geoContext'

import { useHasMounted } from '@/lib/hooks/useHasMounted'
import { getCompanyNameByCountry } from '@/lib/utils/countryValues'

export const Copyright: React.FC = () => {
  const { country } = useContext(GeoContext)
  const hasMounted = useHasMounted()
  const year = new Date().getFullYear()

  // Match the server (no geo) on first client render, then swap in the real country.
  const countryForCopy = hasMounted ? country : ''

  return (
    <DSText as="span" variant="fluid-label-100" color="primary-inverse">
      &copy;{year} {getCompanyNameByCountry(countryForCopy)}
    </DSText>
  )
}
